import React, { type PropsWithChildren } from 'react'
import { createTheme, ThemeProvider } from '@mui/material/styles'

declare module '@mui/material/styles' {
  interface Theme {
    props?: object
  }

  // allow configuration using `createTheme`
  interface ThemeOptions {
    props?: object
  }
}

export const ThemeContextProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const theme = createTheme({
    palette: {
      mode: 'dark',
      primary: {
        main: '#9d5fce'
      },
      secondary: {
        main: '#897B90',
        dark: '#6c5b75',
      }
    },
    typography: {
      fontSize: 14,
      allVariants: {
        fontFamily: ['Mulish', 'Helvetica', 'Arial', 'sans-serif'].join(','),
      },
    },
    props: {
      MuiList: {
        dense: true
      },
      MuiMenuItem: {
        dense: true
      },
      MuiTable: {
        size: 'small'
      },
      MuiButton: {
        size: 'small'
      },
      MuiButtonGroup: {
        size: 'small'
      },
      MuiCheckbox: {
        size: 'small'
      },
      MuiFab: {
        size: 'small'
      },
      MuiFormControl: {
        margin: 'dense',
        size: 'small'
      },
      MuiFormHelperText: {
        margin: 'dense'
      },
      MuiIconButton: {
        size: 'small'
      },
      MuiInputBase: {
        margin: 'dense'
      },
      MuiInputLabel: {
        margin: 'dense'
      },
      MuiRadio: {
        size: 'small'
      },
      MuiSwitch: {
        size: 'small'
      },
      MuiTextField: {
        margin: 'dense',
        size: 'small'
      },
      MuiTooltip: {
        arrow: true
      },
      MuiButtonBase: {
        disableRipple: true
      }
    },
    components: {
      MuiCardContent: {
        styleOverrides: {
          root: {
            padding: 8,
            '&:last-child': {
              paddingBottom: 8
            }
          }
        }
      },
      MuiTableCell: {
        styleOverrides: {
          root: {
            padding: 0
          }
        }
      },
      MuiOutlinedInput: {
        styleOverrides: {
          input: {
            padding: '6px 4px 2px 4px'
          }
        }
      }
    }
  })

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>
}
